<h4 class="sidebar-title">{{ 'CRUD_SETTINGS.CATEGORIES.TITLE' | translate }}</h4>
<ul class="item-list">
  <li 
    *ngFor="let item of sidebarItems; let i = index"
    [class.active]="item === selectedItem"
    (click)="selectItem(item, i)">
    {{ item | translate}}
  </li>
</ul>
